module.exports = __webpack_public_path__ + "images/marketing/peeps/jackie_dasso.jpg";